import { gql, useMutation } from '@apollo/client'

export const SHARE_STORY = gql`
  mutation ($input: GlobalInboxItemCreate) {
    createGlobalInboxItem(input: $input) {
      id
    }
  }
`

export const useShareStory = () => {
  const [mutate, { data, loading, error }] = useMutation(SHARE_STORY, {
    update(cache) {
      cache.modify({
        fields: {
          getFeedsByCampaignId() {},
          getGlobalInbox() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
